/*
 * NOVESTA Judge.me default sort
 * Version: v1.6
 * Updated: 2026-08-04 13:07 JST
 * v1.6: Retries snippet readiness for up to 60 seconds when Judge.me loads late.
 * v1.5: Supports Judge.me V2 carousel markup when revealing the review snippet.
 * v1.4: Reveals the product review snippet only after Judge.me completes its slider layout.
 * Keeps latest sorting without moving the initial product-page viewport to Judge.me.
 */

(() => {
  let hasRequestedMostRecent = false;
  let observer;
  let snippetRevealPending = false;
  let snippetRevealRetryTimer;
  let snippetRevealRetryAttempts = 0;

  const scheduleSnippetRevealRetry = () => {
    if (snippetRevealRetryTimer || snippetRevealRetryAttempts >= 240) {
      return false;
    }

    snippetRevealRetryTimer = window.setTimeout(() => {
      snippetRevealRetryTimer = undefined;
      snippetRevealRetryAttempts += 1;
      revealReviewSnippet();
    }, 250);

    return false;
  };

  const revealReviewSnippet = () => {
    const wrapper = document.querySelector('#jdgm-review-snippet-wrapper');
    const legacyCards = wrapper?.querySelector(
      '.jdgm-rev-snippet-widget__cards-container'
    );
    const cards =
      legacyCards || wrapper?.querySelector('.jm-carousel__track');
    const firstCard = cards?.querySelector('.jdgm-rev-snippet-card');

    if (wrapper?.dataset.novestaSnippetReady === 'true') {
      window.clearTimeout(snippetRevealRetryTimer);
      snippetRevealRetryTimer = undefined;
      return true;
    }
    if (!wrapper || !cards || !firstCard) return scheduleSnippetRevealRetry();
    if (legacyCards && !legacyCards.style.width) {
      return scheduleSnippetRevealRetry();
    }

    const cardsDisplay = window.getComputedStyle(cards).display;
    if (cardsDisplay !== 'flex' && cardsDisplay !== 'inline-flex') {
      return scheduleSnippetRevealRetry();
    }

    const cardsRect = cards.getBoundingClientRect();
    const firstCardRect = firstCard.getBoundingClientRect();
    if (
      cardsRect.width <= 0 ||
      cardsRect.height <= 0 ||
      firstCardRect.width <= 0 ||
      firstCardRect.height <= 0
    ) {
      return scheduleSnippetRevealRetry();
    }

    if (snippetRevealPending) return false;

    snippetRevealPending = true;
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        wrapper.dataset.novestaSnippetReady = 'true';
        snippetRevealPending = false;
      });
    });

    return true;
  };

  const arrangeToolbar = () => {
    const widget = document.querySelector('.jdgm-review-widget');
    const searchRow = widget?.querySelector('.jdgm-row-search');
    const actionsRow = widget?.querySelector('.jdgm-row-actions');

    if (!searchRow || !actionsRow) return false;

    if (searchRow.parentElement !== actionsRow) {
      actionsRow.prepend(searchRow);
    }

    actionsRow.dataset.novestaToolbar = 'true';
    return true;
  };

  const arrangeMedal = () => {
    const widget = document.querySelector('.jdgm-review-widget');
    const starsRow = widget?.querySelector('.jdgm-row-stars');
    const medal = widget?.querySelector('.jdgm-medals-wrapper');
    const actions = starsRow?.querySelector('.jdgm-widget-actions-wrapper');

    if (!starsRow || !medal || !actions) return false;

    if (medal.parentElement !== starsRow || medal.nextElementSibling !== actions) {
      starsRow.insertBefore(medal, actions);
    }

    medal.dataset.novestaMedalPosition = 'header';
    return true;
  };

  const refreshMostRecentWithoutJump = (sort) => {
    const startX = window.scrollX;
    const startY = window.scrollY;
    const cancelEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    let cancelled = false;
    let cleanupTimer;

    const cleanup = () => {
      window.removeEventListener('scroll', restoreScroll);
      cancelEvents.forEach((eventName) => {
        window.removeEventListener(eventName, cancelRestore, true);
      });
      window.clearTimeout(cleanupTimer);
    };

    const cancelRestore = () => {
      cancelled = true;
      cleanup();
    };

    const restoreScroll = () => {
      if (!cancelled) {
        window.scrollTo(startX, startY);
      }
      cleanup();
    };

    cancelEvents.forEach((eventName) => {
      window.addEventListener(eventName, cancelRestore, {
        once: true,
        capture: true,
        passive: true,
      });
    });
    window.addEventListener('scroll', restoreScroll, {
      once: true,
      passive: true,
    });
    cleanupTimer = window.setTimeout(cleanup, 1200);

    sort.value = 'most-recent';
    sort.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const requestMostRecent = () => {
    if (hasRequestedMostRecent) return true;

    const sort = document.querySelector(
      '.jdgm-review-widget select.jdgm-sort-dropdown'
    );
    const mostRecentOption = sort?.querySelector(
      'option[value="most-recent"]'
    );

    if (!sort || !mostRecentOption) return false;

    hasRequestedMostRecent = true;

    if (sort.value === 'most-recent') return true;

    refreshMostRecentWithoutJump(sort);
    return true;
  };

  const enhanceWidget = () => {
    revealReviewSnippet();
    arrangeToolbar();
    arrangeMedal();
    requestMostRecent();
  };

  const initialize = () => {
    enhanceWidget();

    observer = new MutationObserver(enhanceWidget);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    window.setTimeout(() => observer.disconnect(), 15000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
